import { ImageObject } from "@/modules/images";

import imageCover from "@/content/_images/projects/flipside-ones-and-zeroes/cover.jpg";
import imageStyleKit from "@/content/_images/projects/flipside-ones-and-zeroes/stylekit.png";
import imageGraph from "@/content/_images/projects/flipside-ones-and-zeroes/graph.jpg";

import iamgeWireframes1 from "@/content/_images/projects/flipside-ones-and-zeroes/wireframes-1.jpg";
import iamgeWireframes2 from "@/content/_images/projects/flipside-ones-and-zeroes/wireframes-2.jpg";
import imageLofi from "@/content/_images/projects/flipside-ones-and-zeroes/lofi.png";
import imageHifiDev from "@/content/_images/projects/flipside-ones-and-zeroes/hifi-dev.png";
import imageHifiDevFinal from "@/content/_images/projects/flipside-ones-and-zeroes/hifi-dev-final.png";

import imageOutcomes1 from "@/content/_images/projects/flipside-ones-and-zeroes/outcomes-1.jpg";
import imageOutcomes2 from "@/content/_images/projects/flipside-ones-and-zeroes/outcomes-2.jpg";
import imageOutcomes3 from "@/content/_images/projects/flipside-ones-and-zeroes/outcomes-3.jpg";
import imageOutcomes4 from "@/content/_images/projects/flipside-ones-and-zeroes/outcomes-4.jpg";
import imageOutcomes5 from "@/content/_images/projects/flipside-ones-and-zeroes/outcomes-5.jpg";
import imageOutcomes6 from "@/content/_images/projects/flipside-ones-and-zeroes/outcomes-6.jpg";
import imageOutcomes7 from "@/content/_images/projects/flipside-ones-and-zeroes/outcomes-7.jpg";

const images: ImageObject = {
	"p/ones-and-zeros/cover": {
		src: imageCover,
		alt: "The logo of Ones and Zeros, a digital upskilling platform."
	},
	"p/ones-and-zeros/stylekit": {
		src: imageStyleKit,
		alt: "A sheet of styles and components."
	},
	"p/ones-and-zeroes/graph": {
		src: imageGraph,
		alt: "A graph showing digital competency in relation to age and screen time."
	},
	"p/ones-and-zeroes/wireframes-1": {
		src: iamgeWireframes1,
		alt: "Wireframes of the app (home & search)."
	},
	"p/ones-and-zeroes/wireframes-2": {
		src: iamgeWireframes2,
		alt: "Wireframes of the app (learning)."
	},
	"p/ones-and-zeroes/lofi": {
		src: imageLofi,
		alt: "In-development low-fidelity designs of the app."
	},
	"p/ones-and-zeroes/hifi-dev": {
		src: imageHifiDev,
		alt: "In-development high-fidelity designs of the app."
	},
	"p/ones-and-zeroes/hifi-dev-final": {
		src: imageHifiDevFinal,
		alt: "In-development high-fidelity designs of the app."
	},
	"p/ones-and-zeroes/outcomes-1": {
		src: imageOutcomes1,
		alt: "Screenshots of the app's startup."
	},
	"p/ones-and-zeroes/outcomes-2": {
		src: imageOutcomes2,
		alt: "Screenshots of the app's auth flow."
	},
	"p/ones-and-zeroes/outcomes-3": {
		src: imageOutcomes3,
		alt: "Screenshots of the app as a new/core level user."
	},
	"p/ones-and-zeroes/outcomes-4": {
		src: imageOutcomes4,
		alt: "Screenshots of the app's learning experience."
	},
	"p/ones-and-zeroes/outcomes-5": {
		src: imageOutcomes5,
		alt: "Screenshots of the app's learning experience (continued)."
	},
	"p/ones-and-zeroes/outcomes-6": {
		src: imageOutcomes6,
		alt: "Screenshots of the app as a advanced level user."
	},
	"p/ones-and-zeroes/outcomes-7": {
		src: imageOutcomes7,
		alt: "Screenshots of the app as a professional level user."
	}
};

export default images;
